import { Link } from 'react-router-dom';
import p1 from "../images/p1.png";
import ArduinoClockJpg from "../images/ArduinoClock.jpg";
import bqms from "../images/bqms.png";

const projects = [
  {
    title: 'Door Lock System',
    desc: 'Digital logic keypad lock with status indicators.',
    to: '/projects/door-lock',
    image: p1,
  },
  {
    title: 'Arduino-Based Multi-Function Digital Clock',
    desc: 'Digital Clock With Date, Time, and Temperature.',
    to: '/projects/arduino-clock',
    image: ArduinoClockJpg,
  },
  {
    title: 'Bank Queue Management System',
    desc: 'Streamlined customer flow with digital ticketing and display.',
    to: '/projects/bank-queue',
    image: bqms,
  },
  {
    title: 'Energy Meter',
    desc: 'Energy usage tracking with per-circuit insights.',
    to: '/projects/energy-meter',
    image: '/images/p1.png',
  },
];

function Projects() {
  return (
    <section id="projects" className="section section--projects">
      <div className="section-heading">
        <h1>Projects</h1>
        <p>Hover to peek and click to view details.</p>
      </div>
      <div className="projects-grid">
        {projects.map((project, idx) => (
          <Link className="project-card" to={project.to} key={`${project.to}-${idx}`}>
            <div
              className="project-card__image"
              style={{ backgroundImage: `url('${project.image}')` }}
              aria-label={`${project.title} cover`}
            />
            <div className="project-card__overlay">
              <div>
                <h3>{project.title}</h3>
                <p>{project.desc}</p>
              </div>
              <button className="project-card__cta">more</button>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default Projects;
